import { Network } from './commons';

export const StaticDataService = {
  index: async () => {
    const { data } = await Network.get('admin/static_data');
    return data;
  }
};
